export default {
  TITLE: 'App Permissions Explanation',
  CONTENT: `
    <h3>Android Operating System App Permissions</h3>
    <table>
      <tr>
        <th>Permission Name</th>
        <th>Function Description</th>
        <th>Usage Scenario</th>
      </tr>
      <tr>
        <td>INTERNET</td>
        <td>Allows the app to connect to the network and send statistical data</td>
        <td>Push notifications, TalkingData embedding</td>
      </tr>
      <tr>
        <td>ACCESS_NETWORK_STATE</td>
        <td>Allows the app to detect network connection status and pause data transmission in case of network abnormalities</td>
        <td>Push notifications, TalkingData embedding</td>
      </tr>
      <tr>
        <td>ACCESS_WIFI_STATE</td>
        <td>Obtain the device's MAC address, also used to identify unique users</td>
        <td>Push notifications, TalkingData embedding</td>
      </tr>
      <tr>
        <td>VIBRATE</td>
        <td>Vibration permission (mandatory for notification function)</td>
        <td>Push notifications</td>
      </tr>
      <tr>
        <td>GET_TASKS</td>
        <td>Get task information, the purpose is to prevent the SDK from being frequently awakened</td>
        <td>Push notifications</td>
      </tr>
      <tr>
        <td>SCHEDULE_EXACT_ALARM</td>
        <td>Compatible with Android 12 alarm permission</td>
        <td>Push notifications</td>
      </tr>
      <tr>
        <td>BADGE_ICON</td>
        <td>Vivo badge setting</td>
        <td>Push notifications</td>
      </tr>
      <tr>
        <td>READ PHONE STATE</td>
        <td>
          Allows the app to access phone device information in read-only mode, using the obtained information to uniquely identify users
        </td>
        <td>TalkingData embedding</td>
      </tr>
      <tr>
        <td>WRITE EXTERNAL STORAGE</td>
        <td>Used to save device information, as well as record logs; save posters to local albums</td>
        <td>TalkingData embedding, sharing</td>
      </tr>
      <tr>
        <td>READ_CLIPBOARD</td>
        <td>Read clipboard information</td>
        <td>PAKOL</td>
      </tr>
      <tr>
        <td>READ_EXTERNAL_STORAGE</td>
        <td>Read album information for uploading pictures</td>
        <td>Filling and uploading ID card photos on the customs information page</td>
      </tr>
      <tr>
        <td>MANAGE_ACCOUNTS</td>
        <td>Used to indicate that the app has the ability to manage accounts. When apps need to create, modify, or delete user account information, they need to declare this permission</td>
        <td>Login and registration</td>
      </tr>
      <tr>
        <td>USE_CREDENTIALS</td>
        <td>Allows the app to request verification of authtoken from AccountManager</td>
        <td>Login and registration</td>
      </tr>
      <tr>
        <td>GET_ACCOUNTS</td>
        <td>Allows the app to access account information on the device</td>
        <td>Login and registration</td>
      </tr>
      <tr>
        <td>AUTHENTICATE_ACCOUNTS</td>
        <td>Used to indicate that the app has the ability to authenticate accounts</td>
        <td>Login and registration</td>
      </tr>
    </table>
    <h3>iOS Operating System App Permissions</h3>
    <table>
      <tr>
        <th>Permission Name</th>
        <th>Function Description</th>
        <th>Usage Scenario</th>
        <th>Is Content Customizable</th>
        <th>Popup Content</th>
      </tr>
      <tr>
        <td>Privacy - Photo Library Additions Usage Description</td>
        <td>Save pictures to the album</td>
        <td>Clicking the share button on the product details page, saving posters to the album</td>
        <td>Yes</td>
        <td>Only programs and features that you allow to save photos can use it. For example: saving posters</td>
      </tr>
      <tr>
        <td>Privacy - Camera Usage Description</td>
        <td>Camera function</td>
        <td>KYC upload pictures</td>
        <td>Yes</td>
        <td>Only programs and features that you allow to use the camera can use it. For example: selecting ID card pictures for upload</td>
      </tr>
      <tr>
        <td>Privacy - Photo Library Usage Description</td>
        <td>Album</td>
        <td>KYC upload pictures</td>
        <td>Yes</td>
        <td>Only programs and features that you allow to use the album can use it. For example: selecting ID card pictures for upload</td>
      </tr>
      <tr>
        <td>Privacy - Tracking Usage Description</td>
        <td>IDFA</td>
        <td>Use of TalkingDataSDK</td>
        <td>Yes</td>
        <td>Obtain device information to accurately push content you like</td>
      </tr>
      <tr>
        <td>Push</td>
        <td>Message push</td>
        <td>Message push</td>
        <td>No</td>
        <td>
          <img class="img-round" src="https://m.media-amazon.com/images/G/28/GlobalStoreMobileShoppingWebapp/assets/image/protocol/permission_description_push.jpg" alt="" />
        </td>
      </tr>
      <tr>
        <td>Clipboard</td>
        <td>Get clipboard content</td>
        <td>Deep Link when the app is not installed</td>
        <td>No</td>
        <td>
          <img class="img-round" src="https://m.media-amazon.com/images/G/28/GlobalStoreMobileShoppingWebapp/assets/image/protocol/permission_description_clipBoard.jpg" alt="" />
        </td>
      </tr>
      <tr>
        <td>Access WiFi Information</td>
        <td>Obtain Wifi information</td>
        <td>TalkingDataSDK attribution</td>
        <td>-</td>
        <td>No popup (not confirmed yet)</td>
      </tr>
      <tr>
        <td>Privacy - Location When In Use Usage Description</td>
        <td>Obtain location permission</td>
        <td>TalkingDataSDK attribution requires obtaining Wifi information. After iOS 13, obtaining Wifi information requires enabling location permissions.</td>
        <td>Yes</td>
        <td>Obtaining wifi information requires enabling location permissions</td>
      </tr>
    </table>
  `
};
